import React from "react";
import Tag from "antd/lib/tag";
import { TagProps } from "antd";
import "./index.less";

const ZTag: React.FC<TagProps> = ({ children, ...rest }) => {
	const tagColor = rest.color;
	return (
		<Tag className="z-tag" color={tagColor} {...rest}>
			{children}
		</Tag>
	);
};

export default ZTag;
